module.exports = __webpack_public_path__ + "assets/img/3_1397_big.84e765c4.jpg";